import React from 'react';
import {
    LICENSING_SOLUTIONS_LIST_DATA_TEST_ID,
    LICENSING_SOLUTIONS
} from './licensing-constants';
import Tooltip from 'rc-tooltip';
import { getClassName } from '../../../../helpers/dom-helpers';
import PropTypes from 'prop-types';

const LicensingSolutionsList = ({
    getSolutionLicenceExpirationTooltip,
    getSolutionProgressColor,
    checkSolutionDisabled
}) => {
  const getSolutionTooltipOverlay = (solutionLabel, solutionFullName) => {
    return checkSolutionDisabled(solutionLabel)
           ? <div>{getSolutionLicenceExpirationTooltip(solutionLabel)}</div>
           : <div>
                <div>{solutionFullName}</div>
                <div>
                  {getSolutionLicenceExpirationTooltip(
                    solutionLabel
                  )}
                </div>
            </div>
  }

    return (
        <div
            data-testid={LICENSING_SOLUTIONS_LIST_DATA_TEST_ID}
            className="glu-licensing-solutions"
        >
            <Tooltip
                placement="topLeft"
                trigger={['hover']}
                overlay={(
                    <div>
                        <div>Gluware solutions that are licensed. Your</div>
                        <div>role may limit access to some solutions.</div>
                    </div>
                )}
            >
                <p className="glu-licensing-solutions__title">
                    Licensed solutions
                </p>
            </Tooltip>
            <div className="glu-solutions">
                {LICENSING_SOLUTIONS.map((licensingSolution) => {
                    return (
                        <Tooltip
                            key={licensingSolution.fullName}
                            placement="top"
                            trigger={['hover']}
                            overlay = {getSolutionTooltipOverlay(licensingSolution.label, licensingSolution.fullName)}
                        >
                            <div
                                className="glu-solution__pair--wrapper"
                                key={licensingSolution.label}
                                id={licensingSolution.label}
                            >
                                <div className="glu-solution__pair">
                                    <div
                                        className={getClassName(
                                          `g-icon-${licensingSolution.iconName}`, 'glu-license-icon',
                                                { 'glu-license-icon--disabled': checkSolutionDisabled(
                                                       licensingSolution.label
                                                )}
                                          )}
                                        style={{
                                            color: getSolutionProgressColor(
                                                licensingSolution.label
                                            )
                                        }}
                                    />
                                    <p
                                        className={getClassName(
                                            'glu-license-title',
                                            {
                                                ' glu-license-title--disabled': checkSolutionDisabled(
                                                    licensingSolution.label
                                                )
                                            }
                                        )}
                                    >
                                        {licensingSolution.label}
                                    </p>
                                </div>
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
        </div>
    );
};

LicensingSolutionsList.propTypes = {
    getSolutionLicenceExpirationTooltip: PropTypes.func.isRequired,
    getSolutionProgressColor: PropTypes.func.isRequired,
    checkSolutionDisabled: PropTypes.func.isRequired
};

export default LicensingSolutionsList;